module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_21.png?632b610f593d1d3617ce19ddd99e23d4";